<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Stat from "@/components/widgets/stat";
import Loader from "../components/loader";
import api from "@/axios";
import moment from "moment/moment";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {
  page: {
    title: "Comercial",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Stat,
    Loader,
  },
  data() {
    return {

      ultimosPedidos: null,
      ultimosOrcamentos: null,
      estadosDestaque: null,
      cidadesDestaque: null,
      seriesSemestre: null,
      prodDestaqueMes: {},
      totalizadores: {},
      userLogged: {},
      updating: true,
      title: "Dashboard",
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Default",
          active: true,
        },
      ],
      cardsData: [],


      transactions: [
        {
          id: "#SK2540",
          name: "Cliente Testes 099",
          date: "07 Mar, 2023",
          total: "R$ 400",
          status: "Quitado",
          payment: ["fa-cc-mastercard", "Mastercard"],
          index: 1,
        },
        {
          id: "#SK2541",
          name: "Cliente Testes 098",
          date: "07 Mar, 2023",
          total: "R$ 380",
          status: "Bloqueado",
          payment: ["fa-cc-visa", "Visa"],
          index: 2,
        },
        {
          id: "#SK2542",
          name: "Cliente Testes 100",
          date: "06 Mar, 2023",
          total: "R$ 384",
          status: "Quitado",
          payment: ["fab fa-cc-paypal", "Paypal"],
          index: 3,
        },
        {
          id: "#SK2543",
          name: "Cliente Testes 055",
          date: "05 Mar, 2023",
          total: "R$ 412",
          status: "Quitado",
          payment: ["fa-cc-mastercard", "Mastercard"],
          index: 4,
        },
        {
          id: "#SK2544",
          name: "Cliente Testes 099",
          date: "04 Mar, 2023",
          total: "R$ 404",
          status: "Análise",
          payment: ["fa-cc-visa", "Visa"],
          index: 5,
        },
        {
          id: "#SK2545",
          name: "Cliente Testes 187",
          date: "04 Mar, 2023",
          total: "R$ 392",
          status: "Quitado",
          payment: ["fab fa-cc-paypal", "Paypal"],
          index: 6,
        },
      ],
      showModal: false,
      isLoading: false,
      fullPage: true,
      canCancel: false,
      useSlot: false,
      loader: "spinner",
      color: "#007bff",
      bgColor: "#ffffff",
      height: 128,
      width: 128,
      timeout: 3000, //ms
      fetchingStats: true,
      earningStatus: true,

      chartProdDestaqOptions: {
        chart: {
          height: 200,
          type: "radialBar",
          offsetY: -10,
        },
        plotOptions: {
          radialBar: {
            startAngle: -135,
            endAngle: 135,
            dataLabels: {
              name: {
                fontSize: "13px",
                color: undefined,
                offsetY: 60,
              },
              value: {
                offsetY: 22,
                fontSize: "16px",
                color: undefined,
                formatter: function (val) {
                  return val + "%";
                },
              },
            },
          },
        },
        colors: ["#556ee6"],
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            shadeIntensity: 0.15,
            inverseColors: false,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 50, 65, 91],
          },
        },
        stroke: {
          dashArray: 4,
        },
        labels: ["Participação Produto"],
      },
      seriesProdDestaq: [0],




      isActiveSemFiltro: "valor",
      seriesSem: [],
      chartOptionsSem: {
        chart: {
          stacked: true,
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: true,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "15%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ],
        },
        colors: ["#556ee6", "#f1b44c", "#34c38f"],
        legend: {
          position: "bottom",
        },
        fill: {
          opacity: 1,
        },
      },

    };
  },

  methods: {


    editarPedido(idData){
      console.log('editar: ' + idData)
      this.$router.push(`/pedido/detalhe/${idData}`)
    },

    changeValSem(value) {
      switch (value) {
        case "conta":
          this.isActiveSemFiltro = "conta";
          this.seriesSem = [
            {
              name: "Confirmado",
              data: this.seriesSemestre[0],
            },
            {
              name: "Elaboração",
              data: this.seriesSemestre[3],
            },
            {
              name: "Faturado",
              data: this.seriesSemestre[6],
            },
          ];
          break;
        case "peso":
          this.isActiveSemFiltro = "peso";
          this.seriesSem = [
            {
              name: "Confirmado",
              data: this.seriesSemestre[1],
            },
            {
              name: "Elaboração",
              data: this.seriesSemestre[4],
            },
            {
              name: "Faturado",
              data: this.seriesSemestre[7],
            },
          ];
          break;
        case "valor":
          this.isActiveSemFiltro = "valor";
          this.seriesSem = [
            {
              name: "Confirmado",
              data: this.seriesSemestre[2],
            },
            {
              name: "Elaboração",
              data: this.seriesSemestre[5],
            },
            {
              name: "Faturado",
              data: this.seriesSemestre[8],
            },
          ];
          break;
        default:
          this.seriesSem = [
            {
              name: "Confirmado",
              data: this.seriesSemestre[2],
            },
            {
              name: "Elaboração",
              data: this.seriesSemestre[5],
            },
            {
              name: "Faturado",
              data: this.seriesSemestre[8],
            },
          ];
          break;
      }
    },

    nomeTipo(strEntr){
      let result = 'Não Definido'
      switch (strEntr) {
        case 'admin':
          result = 'Administrador'
          break
        case 'repres':
          result = 'Representante'
          break
        case 'superv':
          result = 'Supervisor'
          break
        case 'gerent':
          result = 'Gerente'
          break
        default:
          result = 'Não Definido'
          break
      }
      return result
    },

    nomeEstado(strEntr){
      let result = 'Não Definido'
      switch (strEntr) {
        case 'AC':
          result = 'Acre'
          break;
        case 'AL':
          result = 'Alagoas'
          break;
        case 'AP':
          result = 'Amapá'
          break;
        case 'AM':
          result = 'Amazonas'
          break;
        case 'BA':
          result = 'Bahia'
          break;
        case 'CE':
          result = 'Ceará'
          break;
        case 'DF':
          result = 'Distrito Federal'
          break;
        case 'ES':
          result = 'Espírito Santo'
          break;
        case 'GO':
          result = 'Goiás'
          break;
        case 'MA':
          result = 'Maranhão'
          break;
        case 'MT':
          result = 'Mato Grosso'
          break;
        case 'MS':
          result = 'Mato Grosso do Sul'
          break;
        case 'MG':
          result = 'Minas Gerais'
          break;
        case 'PA':
          result = 'Pará'
          break;
        case 'PB':
          result = 'Paraíba'
          break;
        case 'PR':
          result = 'Paraná'
          break;
        case 'PE':
          result = 'Pernambuco'
          break;
        case 'PI':
          result = 'Piauí'
          break;
        case 'RJ':
          result = 'Rio de Janeiro'
          break;
        case 'RN':
          result = 'Rio Grande do Norte'
          break;
        case 'RS':
          result = 'Rio Grande do Sul'
          break;
        case 'RO':
          result = 'Rondônia'
          break;
        case 'RR':
          result = 'Roraima'
          break;
        case 'SC':
          result = 'Santa Catarina'
          break;
        case 'SP':
          result = 'São Paulo'
          break;
        case 'SE':
          result = 'Sergipe'
          break;
        case 'TO':
          result = 'Tocantins'
          break;
        default:
          result = 'Não Definido'
          break
      }
      return result
    },

    nomeStatusPedido(strEntr){
      let result = 'Não Definido'
      switch (strEntr) {
        case 'FA':
          result = 'Faturado'
          break
        case 'EL':
          result = 'Elaboração'
          break
        case 'CA':
          result = 'Cancelado'
          break
        case 'CO':
          result = 'Confirmado'
          break
        default:
          result = 'Não Definido'
          break
      }
      return result
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return "0,00";
    },

    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

  },

  mounted() {
    console.log('mounted_dashPrincipal_0')

    this.userLogged = JSON.parse(localStorage.getItem('user'))

    // não exibir modal newsletter
    // setTimeout(() => {
    //   this.showModal = true;
    // }, 1500);

    // console.log('getBaseUrl()')
    // console.log(getBaseUrl())
    // console.log('novaFuncao...... getBaseUrl()')
    // console.log(getBaseUrl())

    api.get(`${getBaseUrl()}api/indexvendas`).then((res) => {
      console.log('then axios')
      console.log(res)

      this.totalizadores = res.data[0]

      this.totalizadores.contorctosem = parseFloat(this.totalizadores.contorctosem)
      this.totalizadores.valorsemana = parseFloat(this.totalizadores.valorsemana)
      let tickMedio = (this.totalizadores.valorsemana / this.totalizadores.contorctosem).toFixed(2)

      this.cardsData = [
        {
          icon: "bx bx-copy-alt",
          title: "Orçamentos Semana",
          value: this.formatInteger(this.totalizadores.contorctosem),
        },
        {
          icon: "bx bx-archive-in",
          title: "Faturado",
          value: "R$ " + this.formatDecimal(this.totalizadores.valorsemana),
        },
        {
          icon: "bx bx-purchase-tag-alt",
          title: "Ticket Médio",
          value: "R$ " + this.formatDecimal(tickMedio),
        },
      ]

      if (res.data[1]) {

        this.prodDestaqueMes = res.data[1]
        this.prodDestaqueMes.vlrtotal = parseFloat(this.prodDestaqueMes.vlrtotal)
        let percPartProd = (this.prodDestaqueMes.vlrtotal / this.totalizadores.valorsemana).toFixed(2)
        percPartProd = (percPartProd * 100).toFixed(0)
        this.seriesProdDestaq = [percPartProd]
      }


      this.seriesSemestre = res.data[2]
      this.seriesSem = [
        {
          name: "Confirmado",
          data: this.seriesSemestre[2],
        },
        {
          name: "Elaboração",
          data: this.seriesSemestre[5],
        },
        {
          name: "Faturado",
          data: this.seriesSemestre[8],
        },
      ]

      this.estadosDestaque = res.data[3]
      this.ultimosOrcamentos = res.data[4]
      this.cidadesDestaque = res.data[5]

      this.ultimosPedidos = res.data[6]

      this.updating = false
    })


  }

};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <Loader v-if="updating" style="min-height: 250px;">
    </Loader>

    <Loader class="mt-4" v-if="updating" style="min-height: 250px;">
    </Loader>

    <Loader class="mt-4" v-if="updating" style="min-height: 250px;">
    </Loader>

    <div class="row" v-if="!updating">
      <div class="col-xl-4">

        <div class="card overflow-hidden">
          <div class="bg-soft bg-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-3">
                  <h5 class="text-primary">Bem vindo!</h5>
                  <p>Overview Mês</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div class="row">
              <div class="col-sm-4">
                <div class="avatar-md profile-user-wid mb-4">
                  <img
                      src="@/assets/images/users/avatar.png"
                      alt
                      class="img-thumbnail rounded-circle"/>


                </div>
                <h5 class="font-size-15 text-truncate"> {{ userLogged.nome }} </h5>
                <p class="text-muted mb-0 text-truncate"> {{ nomeTipo(userLogged.tipo) }} </p>
              </div>

              <div class="col-sm-8">
                <div class="pt-4">
                  <div class="row">
                    <div class="col-6">
                      <h5 class="font-size-15"> {{ formatInteger(totalizadores.contorcto) }} </h5>
                      <p class="text-muted mb-0">Orçamentos</p>
                    </div>
                    <div class="col-6">
                      <h5 class="font-size-15">R$ {{ formatDecimal(totalizadores.valconvert) }}</h5>
                      <p class="text-muted mb-0">Convertidos</p>
                    </div>
                  </div>
                  <div class="mt-4">
                    <router-link to="/orcamentos/list" href class="btn btn-primary btn-sm">
                      Abrir Orçamentos
                      <i class="mdi mdi-arrow-right ms-1"></i>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end card-body -->
        </div>

<!--        <Earning :updating="earningStatus" />-->

        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Faturamento de Pedidos</h4>
            <div class="row">
              <div class="col-sm-6">
                <p class="text-muted">Este mês</p>
                <h3>R$ {{ formatDecimal(totalizadores.valfatpedmes) }}</h3>
                <p class="text-muted">
              <span class="text-success me-2">
                100%
                <i class="mdi mdi-arrow-up"></i>
              </span>
                  período anterior
                </p>

                <div class="mt-4">
                  <router-link to="/pedidos/list" href="javascript: void(0);" class="btn btn-primary btn-sm">
                    Mais detalhes
                    <i class="mdi mdi-arrow-right ms-1"></i>
                  </router-link>
                </div>
              </div>
              <div class="col-sm-6">
                <!-- Chart -->
                <apexchart
                    class="apex-charts"
                    type="radialBar"
                    height="200"
                    dir="ltr"
                    :series="seriesProdDestaq"
                    :options="chartProdDestaqOptions"
                ></apexchart>


              </div>
            </div>
            <p class="text-muted mb-0" v-if="prodDestaqueMes">
              Destaque  {{ prodDestaqueMes.descprod }}
            </p>
          </div>
        </div>


      </div>
      <!-- end col -->
      <div class="col-xl-8">
        <div class="row">
          <div v-for="stat of cardsData" :key="stat.icon" class="col-md-4">
            <Stat :icon="stat.icon" :title="stat.title" :value="stat.value" />
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <div class="d-sm-flex flex-wrap">
              <h4 class="card-title mb-4">Anual</h4>
              <div class="ms-auto">
                <ul class="nav nav-pills">
                  <li class="nav-item">
                    <a
                        class="nav-link"
                        href="javascript: void(0);"
                        @click="changeValSem('conta')"
                        :class="{'active': isActiveSemFiltro == 'conta'}"
                    >Contagem</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                        class="nav-link"
                        href="javascript: void(0);"
                        @click="changeValSem('peso')"
                        :class="{'active': isActiveSemFiltro == 'peso'}"
                    >Peso</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                        class="nav-link"
                        href="javascript: void(0);"
                        @click="changeValSem('valor')"
                        :class="{'active': isActiveSemFiltro == 'valor'}"
                    >Valor</a
                    >
                  </li>
                </ul>
              </div>
            </div>

            <apexchart
                class="apex-charts"
                type="bar"
                dir="ltr"
                height="360"
                :series="seriesSem"
                :options="chartOptionsSem"
            ></apexchart>
          </div>
        </div>


      </div>
    </div>
    <!-- end row -->



    <div class="row" v-if="!updating">
      <div class="col-xl-4">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Estados em Destaque</h4>

            <div class="text-center" v-if="estadosDestaque.length > 0">
              <div class="avatar-sm mx-auto mb-4">
              <span class="avatar-title rounded-circle bg-soft bg-primary text-primary">
                 {{ estadosDestaque.length > 0 ? estadosDestaque[0].estado : ''}}
              </span>
              </div>
              <p class="font-16 text-muted mb-2"></p>
              <h5>
                <a href="javascript: void(0);" class="text-dark">
                  <span class="text-muted font-16">R$ {{ formatDecimal(estadosDestaque[0].valorliq) }}</span>
                </a>
              </h5>
              <p class="text-muted" v-if="estadosDestaque.length > 0">
                {{ nomeEstado(estadosDestaque[0].estado) }}
              </p>
              <a href="javascript: void(0);" class="text-primary font-16">
                Mais detalhes
                <i class="mdi mdi-chevron-right"></i>
              </a>
            </div>

            <div class="row mt-4" v-if="estadosDestaque.length > 0">
              <div class="col-sm-4">
                <div class="social-source text-center mt-3">
                  <div class="avatar-xs mx-auto mb-3">
                <span class="avatar-title rounded-circle bg-soft bg-primary text-primary">
                  {{ estadosDestaque.length > 1 ? estadosDestaque[1].estado : ''}}
                </span>
                  </div>
                  <div v-if="estadosDestaque.length > 1">
                    <h5 class="font-size-15">{{ nomeEstado(estadosDestaque[1].estado) }}</h5>
                    <p class="text-muted mb-0">R$ {{ formatDecimal(estadosDestaque[1].valorliq) }}</p>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="social-source text-center mt-3">
                  <div class="avatar-xs mx-auto mb-3">
                <span class="avatar-title rounded-circle bg-soft bg-primary text-primary">
                  {{ estadosDestaque.length > 2 ? estadosDestaque[2].estado : ''}}
                </span>
                  </div>
                  <div v-if="estadosDestaque.length > 2">
                    <h5 class="font-size-15">{{ nomeEstado(estadosDestaque[2].estado) }}</h5>
                    <p class="text-muted mb-0">R$ {{ formatDecimal(estadosDestaque[2].valorliq) }}</p>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="social-source text-center mt-3">
                  <div class="avatar-xs mx-auto mb-3">
                <span class="avatar-title rounded-circle bg-soft bg-primary text-primary">
                  {{ estadosDestaque.length > 3 ? estadosDestaque[3].estado : ''}}
                </span>
                  </div>
                  <div v-if="estadosDestaque.length > 3">
                    <h5 class="font-size-15">{{ nomeEstado(estadosDestaque[3].estado) }}</h5>
                    <p class="text-muted mb-0">R$ {{ formatDecimal(estadosDestaque[3].valorliq) }}</p>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
      <!-- end col -->
      <div class="col-xl-4">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-5">Atividade</h4>
            <ul class="verti-timeline list-unstyled">


              <li class="event-list" v-for="(data, index) in ultimosOrcamentos" :key="data.id">
                <div class="event-timeline-dot" v-if="index === 0">
                  <i class="bx bx-right-arrow-circle font-size-18 bx-fade-right"></i>
                </div>
                <div class="event-timeline-dot" v-else>
                  <i class="bx bx-right-arrow-circle font-size-18 "></i>
                </div>
                <div class="d-flex">
                  <div class="me-3">
                    <h5 class="font-size-14">
                      {{ formatDate(data.dtemissao) }}
                      <i
                          class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"
                      ></i>
                    </h5>
                  </div>
                  <div class="flex-grow-1">
                    <div>Orçamento ({{ data.id }}) R$ {{ formatDecimal(data.valorliq) }}</div>
                  </div>
                </div>
              </li>


            </ul>
            <div class="text-center mt-4">
              <router-link to="/orcamentos/list" href="javascript: void(0);" class="btn btn-primary btn-sm"
              >Mais detalhes <i class="mdi mdi-arrow-right ms-1"></i></router-link
              >
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->
      <div class="col-xl-4">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Cidades em Destaque</h4>

            <div class="text-center">
              <div class="mb-4">
                <i class="bx bx-map-pin text-primary display-4"></i>
              </div>
              <h3>R$ {{ cidadesDestaque && cidadesDestaque.length > 0 ? formatDecimal(cidadesDestaque[0].valorliq) : '' }}</h3>
              <p>{{ cidadesDestaque && cidadesDestaque.length > 0 ? cidadesDestaque[0].cidade : '' }}</p>
            </div>

            <div class="table-responsive mt-4">
              <table class="table table-centered">
                <tbody>

                <tr v-if="cidadesDestaque && cidadesDestaque[1]">
                  <td style="width: 140px">
                    <p class="mb-0">{{ cidadesDestaque && cidadesDestaque.length >= 1 ? cidadesDestaque[1].cidade : '' }}</p>
                  </td>
                  <td style="width: 120px">
                    <h5 class="mb-0">R$ {{ cidadesDestaque && cidadesDestaque.length >= 1 ? formatDecimal(cidadesDestaque[1].valorliq) : '' }}</h5>
                  </td>
                  <td>
                    <b-progress
                        :value="cidadesDestaque[1].perc"
                        variant="primary"
                        height="5px"
                    ></b-progress>
                  </td>
                </tr>

                <tr v-if="cidadesDestaque && cidadesDestaque[2]">
                  <td>
                    <p class="mb-0">{{ cidadesDestaque && cidadesDestaque[2] ? cidadesDestaque[2].cidade : '' }}</p>
                  </td>
                  <td>
                    <h5 class="mb-0">R$ {{ cidadesDestaque && cidadesDestaque[2] ? formatDecimal(cidadesDestaque[2].valorliq) : '' }}</h5>
                  </td>
                  <td>
                    <b-progress
                        :value="cidadesDestaque[2].perc"
                        variant="success"
                        height="5px"
                    ></b-progress>
                  </td>
                </tr>

                <tr v-if="cidadesDestaque && cidadesDestaque[3]">
                  <td>
                    <p class="mb-0">{{ cidadesDestaque && cidadesDestaque[3] ? cidadesDestaque[3].cidade : '' }}</p>
                  </td>
                  <td>
                    <h5 class="mb-0">R$ {{ cidadesDestaque && cidadesDestaque[3] ? formatDecimal(cidadesDestaque[3].valorliq) : '' }}</h5>
                  </td>
                  <td>
                    <b-progress
                        :value="cidadesDestaque[3].perc"
                        variant="success"
                        height="5px"
                    ></b-progress>
                  </td>
                </tr>


                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

    <div class="row" v-if="!updating">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Últimos Pedidos</h4>

            <div class="table-responsive mb-0">
              <table class="table align-middle table-nowrap">
                <thead class="table-light">
                <tr>

                  <th class="align-middle">ID</th>
                  <th class="align-middle">Código</th>
                  <th class="align-middle">Cliente</th>
                  <th class="align-middle">CNPJ</th>
                  <th class="align-middle">Cidade</th>
                  <th class="align-middle">Estado</th>
                  <th class="align-middle">Data</th>
                  <th class="align-middle">Status</th>
                  <th class="align-middle">Método</th>
                  <th class="align-middle">Peso</th>
                  <th class="align-middle">Valor</th>
                  <th class="text-end">Ações</th>
                </tr>
                </thead>
                <tbody>

                <tr v-for="data in ultimosPedidos" :key="data.id">


                  <td>
                    <a href="javascript: void(0);" @click="editarPed(data.id)" class="text-body fw-bold">{{
                        data.id
                      }}</a>
                  </td>

                  <td>
                    <a href="javascript: void(0);" @click="editarPed(data.id)" class="text-body fw-bold">{{
                        data.codigo
                      }}</a>
                  </td>

                  <td>{{ data.nomecli }}</td>
                  <td>{{ data.cnpj }}</td>
                  <td>{{ data.cidade }}</td>
                  <td>{{ data.estado }}</td>
                  <td>{{ formatDateTime(data.created_at) }}</td>


                  <td>
                    <span class="badge badge-pill badge-soft-success font-size-11"
                          :class="{
                            'badge-soft-info': `${data.status}` === 'CO',
                            'badge-soft-danger': `${data.status}` === 'CA',
                            'badge-soft-success': `${data.status}` === 'FA',
                          }">{{ nomeStatusPedido(data.status) }} </span>
                    <p></p>


                  </td>

                  <td>
                    {{ data.condpgto }}
                  </td>
                  <td class="text-end">{{ formatDecimal(data.peso) }}</td>
                  <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
                  <td>

                    <div class="button-items text-end">

<!--                      <b-button variant="outline-success" @click="detalhes(data.id)">-->
<!--                        <i class="mdi mdi-eye d-block font-size-16"></i>-->
<!--                      </b-button>-->

                      <b-button variant="outline-warning" @click="editarPedido(data.id)" :disabled="data.email === 'admin@admin.com.br'">
                        <i class="mdi mdi-pencil d-block font-size-16"></i>
                      </b-button>

                    </div>

                  </td>

                </tr>


<!--                <tr v-for="data in transactions" :key="data.id">-->

<!--                  <td>-->
<!--                    <a href="javascript: void(0);" class="text-body fw-bold">{{-->
<!--                        data.id-->
<!--                      }}</a>-->
<!--                  </td>-->
<!--                  <td>{{ data.name }}</td>-->
<!--                  <td>{{ data.date }}</td>-->
<!--                  <td>{{ data.total }}</td>-->
<!--                  <td>-->
<!--              <span-->
<!--                  class="badge badge-pill badge-soft-success font-size-11"-->
<!--                  :class="{-->
<!--                  'badge-soft-danger': `${data.status}` === 'Bloqueado',-->
<!--                  'badge-soft-warning': `${data.status}` === 'Análise',-->
<!--                }"-->
<!--              >{{ data.status }}</span-->
<!--              >-->
<!--                  </td>-->
<!--                  <td>-->
<!--                    <i :class="`fab ${data.payment[0]} me-1`"></i>-->
<!--                    {{ data.payment[1] }}-->
<!--                  </td>-->


<!--                  <td>-->
<!--                    &lt;!&ndash; Button trigger modal &ndash;&gt;-->
<!--                    <div class="button-items text-end">-->

<!--                      <b-button variant="outline-warning" @click="$router.push('/pedido/detalhe/1')">-->
<!--                        <i class="mdi mdi-open-in-new d-block font-size-16"></i>-->
<!--                      </b-button>-->

<!--                    </div>-->
<!--                  </td>-->




<!--                  <b-modal :id="data.id" title="Order Details" centered>-->
<!--                    <p class="mb-2">-->
<!--                      Product id:-->
<!--                      <span class="text-primary">#SK2540</span>-->
<!--                    </p>-->
<!--                    <p class="mb-4">-->
<!--                      Billing Name:-->
<!--                      <span class="text-primary">Neal Matthews</span>-->
<!--                    </p>-->
<!--                    <div class="table-responsive">-->
<!--                      <table class="table table-centered table-nowrap">-->
<!--                        <thead>-->
<!--                        <tr>-->
<!--                          <th scope="col">Product</th>-->
<!--                          <th scope="col">Product Name</th>-->
<!--                          <th scope="col">Price</th>-->
<!--                        </tr>-->
<!--                        </thead>-->
<!--                        <tbody>-->
<!--                        <tr>-->
<!--                          <th scope="row">-->
<!--                            <div>-->
<!--                              <img-->
<!--                                  src="@/assets/images/product/img-7.png"-->
<!--                                  alt-->
<!--                                  class="avatar-sm"-->
<!--                              />-->
<!--                            </div>-->
<!--                          </th>-->
<!--                          <td>-->
<!--                            <div>-->
<!--                              <h5 class="text-truncate font-size-14">-->
<!--                                Wireless Headphone (Black)-->
<!--                              </h5>-->
<!--                              <p class="text-muted mb-0">$ 225 x 1</p>-->
<!--                            </div>-->
<!--                          </td>-->
<!--                          <td>$ 255</td>-->
<!--                        </tr>-->
<!--                        <tr>-->
<!--                          <th scope="row">-->
<!--                            <div>-->
<!--                              <img-->
<!--                                  src="@/assets/images/product/img-4.png"-->
<!--                                  alt-->
<!--                                  class="avatar-sm"-->
<!--                              />-->
<!--                            </div>-->
<!--                          </th>-->
<!--                          <td>-->
<!--                            <div>-->
<!--                              <h5 class="text-truncate font-size-14">-->
<!--                                Phone patterned cases-->
<!--                              </h5>-->
<!--                              <p class="text-muted mb-0">$ 145 x 1</p>-->
<!--                            </div>-->
<!--                          </td>-->
<!--                          <td>$ 145</td>-->
<!--                        </tr>-->
<!--                        <tr>-->
<!--                          <td colspan="2">-->
<!--                            <h6 class="m-0 text-end">Sub Total:</h6>-->
<!--                          </td>-->
<!--                          <td>$ 400</td>-->
<!--                        </tr>-->
<!--                        <tr>-->
<!--                          <td colspan="2">-->
<!--                            <h6 class="m-0 text-end">Shipping:</h6>-->
<!--                          </td>-->
<!--                          <td>Free</td>-->
<!--                        </tr>-->
<!--                        <tr>-->
<!--                          <td colspan="2">-->
<!--                            <h6 class="m-0 text-end">Total:</h6>-->
<!--                          </td>-->
<!--                          <td>$ 400</td>-->
<!--                        </tr>-->
<!--                        </tbody>-->
<!--                      </table>-->
<!--                    </div>-->
<!--                    <template v-slot:modal-footer>-->
<!--                      <b-button variant="secondary" @click="showModal = false"-->
<!--                      >Close</b-button-->
<!--                      >-->
<!--                    </template>-->
<!--                  </b-modal>-->
<!--                </tr>-->
                </tbody>
              </table>
            </div>


          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

    <b-modal v-model="showModal" hide-footer centered header-class="border-0">
      <div class="text-center mb-4">
        <div class="avatar-md mx-auto mb-4">
          <div class="avatar-title bg-light rounded-circle text-primary h1">
            <i class="mdi mdi-email-open"></i>
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-xl-10">
            <h4 class="text-primary">Inscreva-se!</h4>
            <p class="text-muted font-size-14 mb-4">
              Assine nossa newsletter e receba notificação para se manter atualizado.
            </p>

            <div class="input-group bg-light rounded">
              <input
                id="inputRecipientDashPrinc"
                type="email"
                class="form-control bg-transparent border-0"
                placeholder="Insira o endereço de e-mail"
                aria-label="Recipient's username"
                aria-describedby="button-addon2"
              />

              <button class="btn btn-primary" type="button" id="button-addon2">
                <i class="bx bxs-paper-plane"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>
